import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Scroll = styled.div<ContainerProps>`
  width: 100%;
  float: left;

  @media (max-width: 1024px) {
    width: 300%;
    overflow-x: scroll;
  }
`;

export const Container = styled.table<ContainerProps>`
  width: 100%;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-spacing: 0px;
  border-collapse: separate;
`;
